import { render, staticRenderFns } from "./Messaggio.vue?vue&type=template&id=3042a5d8&"
import script from "./Messaggio.vue?vue&type=script&lang=js&"
export * from "./Messaggio.vue?vue&type=script&lang=js&"
import style0 from "./Messaggio.vue?vue&type=style&index=0&id=3042a5d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports